import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { RuleTemplateGrid, RuleTemplateModal } from './components';
import { SCUIButton } from '../../../../../../atomic/atoms';
import { RTT } from './ruleTemplateTab.classes';

export const RuleTemplateTab: FC<any> = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const { t } = useTranslation();

    return (
        <>
            <Box className={RTT.root} sx={{ padding: '16px' }}>
                <SCUIButton
                    className={RTT.createButton}
                    showStartIcon
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    text={t('ruleManagement.createNewRuleTemplateV2')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={() => {
                        setIsModalOpen(true);
                    }}
                />
                <Box className={RTT.gridSection} sx={{ paddingTop: '16px' }}>
                    <RuleTemplateGrid />
                </Box>
            </Box>
            <div className={RTT.modalSection}>
                <RuleTemplateModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            </div>
        </>
    );
};
